// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/language-proficiency.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/language-proficiency/language-proficiency.js';

mount([g0]);
